<template>
	<div class="shop-country-setting">
		<!-- 顶部操作栏 -->
		<div class="top-bar">
			<div class="bar-inner">
				<div class="item">
					<span class="label">选择店铺</span>
					<el-select v-model="selectedShopId" placeholder="请选择店铺" @change="handleShopChange"
						style="width: 240px">
						<el-option v-for="shop in shopList" :key="shop.id" :label="shop.shopName"
							:value="shop.id">
							<span>{{ shop.shopName }}</span>
							<span v-if="shop.isVirtual" class="tag-virtual">（虚拟店铺）</span>
						</el-option>
					</el-select>
				</div>
				<!-- 只能创建一个虚拟店铺 -->
				<div class="item" v-if="!shopState">
					<el-button type="success" @click="openCreateVirtualShopDialog">创建虚拟店铺</el-button>
				</div>
				<!-- 有了真实店铺，加一个按钮把虚拟店铺的数据转到真实店铺中去 -->
				<div class="item" v-else-if="shopState === 'real' && hasVirtualSeller">
					<el-button type="success" @click="transferToRealShop">转移虚拟店铺数据</el-button>
				</div>
				<div class="item">
					<el-button type="primary" @click="saveCurrentShopSetting">保存当前店铺全部国家配置</el-button>
				</div>
				<div class="item">
					<el-button type="primary" @click="batchUpdateDialogVisible = true">批量替换产品流水码</el-button>
				</div>
			</div>
		</div>

		<!-- 统一配置模板区域 套el-form -->
		<el-form ref="formTemplate" :model="tempForm" :rules="templateRules" label-width="0" 			:validate-on-rule-change="false">
			<div class="template-wrap">
				<div class="template-header">
					<div class="txt">统一配置模板</div>
					<div class="form-cell">
						<el-button type="warning" @click="batchFillAllCountry">一键填充全部国家</el-button>
					</div>
				</div>
				<div class="template-row">
					<el-form-item prop="pName" class="form-cell">
						<span class="cell-label">品牌名称：</span>
						<el-input v-model="tempForm.pName" maxlength="20" placeholder="限制最多20位"></el-input>
					</el-form-item>
					<el-form-item prop="cName" class="form-cell">
						<span class="cell-label">厂商名称：</span>
						<el-input v-model="tempForm.cName" maxlength="20" placeholder="和品牌名一致"></el-input>
					</el-form-item>
					<el-form-item prop="set" class="form-cell">
						<span class="cell-label">库存设置：</span>
						<el-input v-model.number="tempForm.set" placeholder="数字"></el-input>
					</el-form-item>
					<el-form-item prop="SKU" class="form-cell">
						<span class="cell-label">父体SKU前缀：</span>
						<el-input v-model="tempForm.SKU" maxlength="6" placeholder="限制最多六位"></el-input>
					</el-form-item>
					<el-form-item prop="pipeCode" class="form-cell">
						<span class="cell-label">流水码起始：</span>
						<el-input v-model="tempForm.pipeCode" maxlength="7" placeholder="数字"></el-input>
					</el-form-item>
					<!-- <el-form-item prop="eanStatus" class="form-cell">
						<span class="cell-label">是否豁免ean：</span>
						<el-select v-model="tempForm.eanStatus">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</el-form-item> -->
				</div>
			</div>
		</el-form>

		<div class="sub-title">各国独立配置（可单独修改，可根据需要在指定国家进行配置）</div>

		<!-- 各国配置外层el-form，共用同一套校验规则 -->
		
		<div class="country-list">
			<div class="country-row" v-for="country in countryList" :key="country.areaName">
				<div class="country-name">{{ country.name }}({{ country.areaName }})</div>
				<el-form :ref="el => setRowFormRef(el, country.areaName)" :model="country" :rules="getRowRules(country)" label-width="0" class="country-input-group" :validate-on-rule-change="false">
					<el-form-item prop="pName" class="form-cell">
						<span class="cell-label">品牌名称：</span>
						<el-input v-model="country.pName" maxlength="20"
							placeholder="限制最多20位"></el-input>
					</el-form-item>
					<el-form-item prop="cName" class="form-cell">
						<span class="cell-label">厂商名称：</span>
						<el-input v-model="country.cName" placeholder="和品牌名一致"
							maxlength="20"></el-input>
					</el-form-item>
					<el-form-item prop="set" class="form-cell">
						<span class="cell-label">库存设置：</span>
						<el-input v-model.number="country.set" placeholder="数字"></el-input>
					</el-form-item>
					<el-form-item prop="SKU" class="form-cell">
						<span class="cell-label">父体SKU编码前缀：</span>
						<el-input v-model="country.SKU" maxlength="6"
							placeholder="限制最多六位"></el-input>
					</el-form-item>
					<el-form-item prop="pipeCode" class="form-cell">
						<span class="cell-label">流水码起始：</span>
						<el-input v-model="country.pipeCode" maxlength="7"
							placeholder="数字"></el-input>
					</el-form-item>
					<!-- <el-form-item prop="eanStatus" class="form-cell">
						<span class="cell-label">是否豁免ean：</span>
						<el-select v-model="country.eanStatus">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</el-form-item> -->
				</el-form>
			</div>
		</div>

		<!-- 创建虚拟店铺弹窗 -->
		<el-dialog title="新增虚拟店铺" :visible.sync="virtualShopDialogVisible" width="400px">
			<div class="dialog-row">
				<span class="dialog-label">店铺名称</span>
				<el-input v-model="virtualShopForm.shopName" placeholder="请输入店铺名称"></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="virtualShopDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="createVirtualShop">确定创建</el-button>
			</div>
		</el-dialog>

		<el-dialog title="批量替换产品流水码" :visible.sync="batchUpdateDialogVisible" width="80%" top="4vh">
			<div class="tip">此操作会把符合条件的产品流水码更新为最新的通用设置</div>
			<!-- 需要区分国家 -->
			<div class="country-list-box">
				<div class="country-row" v-for="country in existCountryList" :key="country.areaName">
					<div class="right-item">
						<div class="label">国家：</div>
						<span>{{ country.areaName }}</span>
					</div>
					<div class="right-item">
						<div class="label">父sku前缀：</div>
						<el-input v-model="country.sku" placeholder="请输入父sku前缀"></el-input>
					</div>
					<div class="right-item">
						<div class="label">流水码起：</div>
						<el-input v-model="country.startNumber" min="1"  placeholder="流水码起始数"></el-input>
					</div>
					<div class="right-item">
						<div class="label">流水码止：</div>
						<el-input v-model="country.endNumber"  placeholder="流水码结束数" style="width: 200px;"></el-input>
					</div>
				</div>
			</div>

			
			<div slot="footer" class="dialog-footer">
				<el-button @click="batchUpdateDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="batchUpdateProductConfirm">确定替换</el-button>
			</div>

		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import { COUNTRY_LIST } from "@/utils/const.js";
const pNameValid = (rule, value, callback) => {
	if (!/^[a-zA-Z]{1,20}$/.test(value)) {
		callback(new Error("只能输入大写字母且不超过20个"));
	} else {
		callback();
	}
};
const checkPipe = (rule, value, callback) => {
	if (/\b(0+)/g.test(value)) {
		callback(new Error("请检查流水码起始数输入是否正确，不能以0开头"));
	} else {
		callback();
	}
};
export default {
	name: "commonPageNew",
	data() {
		const cNameValid = (rule, value, callback) => {
			if (this.tempForm.pName !== value) {
				callback(new Error("品牌名称厂商名称输入不一致"));
			} else {
				callback();
			}
		};
		return {
			countryList: [],
			selectedShopId: "",
			shopList: [],
			batchUpdateDialogVisible: false,
			// 统一模板表单
			tempForm: {
				pName: "",
				cName: "",
				set: "",
				SKU: "",
				pipeCode: "",
				eanStatus: '',
			},
			templateRules: {
				pName: [
					{ validator: pNameValid,  trigger: "blur" }
				],
				cName: [
					{ validator: cNameValid,  trigger: "blur" }
				],
				set: [
					{ type: "number", message: "请输入库存并且只能是数值", trigger: "blur" }
				],
				SKU: [
					{ message: "请输入父体SKU", trigger: "blur" }
				],
				pipeCode: [
					{ validator: checkPipe, trigger: "blur" },
				],
			},
			// 国家表单占位model（el-form必须绑定model，仅用于承载prop校验标识，不做赋值）
			countryFormDummy: {},
			
			str: {},
			// 虚拟店铺弹窗
			virtualShopDialogVisible: false,
			virtualShopForm: {
				shopName: ""
			},
			shopState: "",
			rowFormMap: new Map(),
			userInfo: {},
			hasVirtualSeller: false,
			existCountryList: [],
		};
	},
	mounted() {
		const userInfo = JSON.parse(localStorage.getItem("data")) || {};
		this.userInfo = userInfo.data.user;
		
		this.str = JSON.parse(localStorage.getItem("role"));
		this.initShopList();
	},
	methods: {
		isPositiveInteger(n) {
			// 先转字符串，去掉首尾空格
			const str = String(n).trim();
			// 正则：纯数字，不能以0开头，至少1位，大于0
			return /^[1-9]\d*$/.test(str);
		},
		batchUpdateProductConfirm(){
			const result = [];
			for(let i = 0; i < this.existCountryList.length; i++){
				const item = this.existCountryList[i];
				if ((item.startNumber && !this.isPositiveInteger(item.startNumber)) || (item.endNumber && !this.isPositiveInteger(item.endNumber))) {
					this.$message.error("流水码起始数或结束数输入不正确");
					return;
				}
				
				if (item.startNumber && item.endNumber && item.sku) {
					if (+item.startNumber > +item.endNumber) {
						this.$message.error("流水码起始数不能大于结束数");
						return;
					}
					if(Math.abs(+item.endNumber - +item.startNumber) > 1000){
						this.$message.error("流水码起止间隔不能大于1000");
						return;
					}
					result.push(
						{
							sku: item.sku,
							startNumber: +item.startNumber,
							endNumber: +item.endNumber,
							areaName: item.areaName,
							newBrand: item.newBrand,
							newSku: item.newSku,
						}
					);
				}
			}
			if(result.length === 0){
				this.$message.warning("请至少填写一个国家的品牌、父sku前缀、流水码起始数和结束数");
				return;
			}
			const params = {
				sid: this.selectedShopId,
				staffId: this.str.rid,
				data: result
			}
			ajaxPost(Baseurl + "sellerCommonSettingController/batchUpdateProductPipeCode", params).then(res => {
				if (res.data.code === 200) {
					this.$message.success("产品流水码批量替换成功");
					this.batchUpdateDialogVisible = false;
				} else {
					this.$message.error(res.data.data || "批量替换失败");
				}
			});
		},
		setRowFormRef(el, areaName) {
			if (el) this.rowFormMap.set(areaName, el)
			else this.rowFormMap.delete(areaName)
		},
		getRowRules(rowData) {
			return {
				pName: [
					{ validator: pNameValid, required: true, trigger: "blur" }
				],
				cName: [
					{
						required: true,
						validator: (rule, value, callback) => {
							// ✅ 直接拿到本行表单数据，无跨表单污染
							if (rowData.pName !== value) {
								callback(new Error("品牌名称厂商名称输入不一致"))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				set: [
					{ type: "number", required: true, message: "请输入库存并且只能是数值", trigger: "blur" }
				],
				SKU: [
					{ required: true, message: "请输入父体SKU", trigger: "blur" }
				],
				pipeCode: [
					{ validator: checkPipe, trigger: "blur" },
				],
			}
		},
		// 读取sellerInfo区分真实/虚拟店铺
		async initShopList() {
			const params1 = { staffId: this.str.rid };
			const res1 = await ajaxPost(Baseurl + "sellerController/selectSellerByStaffId", params1);
			if(res1.data.code == 200 && res1.data.data && res1.data.data.length > 0){
				this.shopState = "real";
				this.shopList = res1.data.data.map(item => {
					item.shopName = item.shop_name;
					return item;
				});
				this.selectedShopId = this.shopList[0].id;
				this.handleShopChange();
				const uid = this.str.rid;
				const companyId = this.str.company_id;
				const params = { uid, companyId };
				const res = await ajaxPost(Baseurl + "virtualSellerController/getVirtualSeller", params);
				if (res.data.code === 200 && res.data.data) {
					// 有虚拟店铺
					this.hasVirtualSeller = true;
				}
			}else{
				const uid = this.str.rid;
				const companyId = this.str.company_id;
				const params = { uid, companyId };
				const res = await ajaxPost(Baseurl + "virtualSellerController/getVirtualSeller", params);
				if (res.data.code === 200 && res.data.data) {
					// 有虚拟店铺
					this.shopState = "virtual";
					this.shopList = [res.data.data].map(item => {
						item.isVirtual = true;
						return item;
					});
					this.selectedShopId = this.shopList[0].id;
					this.handleShopChange();
				}else{
					this.$message.warning("当前分配没有店铺，可以先创建虚拟店铺用于创建商品");
				}
			}
		},
		async getVirtualShopList(){
			const uid = this.str.rid;
			const companyId = this.str.company_id;
			try {
				const params = { uid, companyId };
				const res = await ajaxPost(Baseurl + "virtualSellerController/getVirtualSeller", params);
				if (res.data.code === 200) {
					this.initShopList();
					this.virtualShopDialogVisible = false;
					this.$message.success("虚拟店铺创建成功！");
				}
			} catch (err) {
				console.error(err);
			}
		},

		openCreateVirtualShopDialog() {
			this.virtualShopForm.shopName = "";
			this.virtualShopDialogVisible = true;
		},

		// 虚拟店铺数据转移导真实店铺
		transferToRealShop(){
			const params = {
				uid: this.str.rid,
				id: this.selectedShopId,
				companyId: this.str.company_id,
			}
			ajaxPost(Baseurl + "virtualSellerController/transferToRealShop", params).then(res => {
				if (res.data.code === 200) {
					this.$message.success("虚拟店铺数据转移成功！");
					this.initShopList();
					this.hasVirtualSeller = false;
				}
			}).catch(err => {
				console.error(err);
			});
		},
		async createVirtualShop() {
			if (!this.virtualShopForm.shopName.trim()) {
				this.$message.warning("请输入店铺名称");
				return;
			}
			const uid = this.str.rid;
			const companyId = this.str.company_id;
			try {
				await ajaxPost(Baseurl + "virtualSellerController/createOrGet", { uid, companyId, shopName: this.virtualShopForm.shopName });
				const res = await ajaxPost(Baseurl + "virtualSellerController/getVirtualSeller", { uid });
				if (res.data.code === 200) {
					localStorage.setItem("sellerInfo", JSON.stringify({ shopIds: res.data.data }));
					this.initShopList();
					this.virtualShopDialogVisible = false;
					this.$message.success("虚拟店铺创建成功！");
				}
			} catch (err) {
				console.error(err);
			}
		},

		// 获取指定国家配置对象（响应式）
		getCountryForm(areaName) {
			if (!this.selectedShopId) return {};
			
		},

		handleShopChange() {
			if (!this.selectedShopId) return;
			
			this.loadShopConfigFromApi();
		},

		// 一键填充全部国家
		batchFillAllCountry() {
			if (!this.selectedShopId) {
				this.$message.warning("请先选择店铺！");
				return;
			}
			// 先校验模板表单
			this.$refs.formTemplate.validate(valid => {
				if (!valid) return;
				for(const country of this.countryList) {
					country.pName = this.tempForm.pName;
					country.cName = this.tempForm.cName;
					country.set = this.tempForm.set;
					country.SKU = this.tempForm.SKU;
					country.pipeCode = this.tempForm.pipeCode;
					country.eanStatus = this.tempForm.eanStatus;
				}
				this.$message.success("已将模板数据批量填充至全部国家");
				// // 填充完成清除国家表单旧报错
			});
		},

		// 保存配置
		async saveCurrentShopSetting() {
			if (!this.selectedShopId) {
				this.$message.warning("请先选择店铺！");
				return;
			}
			const promiseList = [];
			const updateList = [];
			const obj1 = {};
			this.countryList.forEach(item => {
				const rowData = item;
				const isAllEmpty = [rowData.pName, rowData.cName, rowData.set, rowData.SKU, rowData.pipeCode]
					.every(val => val === '' || val == null);
				if (isAllEmpty) return;

				const formIns = this.rowFormMap.get(item.areaName)
				if (!formIns) return;
				promiseList.push(new Promise(resolve => formIns.validate(v => resolve(v))))
				const item1 = {
					field01: rowData.pName,
					field02: rowData.cName,
					field03: rowData.SKU,
					stock: rowData.set,
					pipeCode: rowData.pipeCode.replace(/\b(0+)/gi, ""),
					countryCode: rowData.areaName,
					eanStatus: rowData.eanStatus,
					...rowData,
				}
				obj1[rowData.areaName] = item1;
				updateList.push(item1);
			})

			const results = await Promise.all(promiseList)
			if (!results.every(Boolean)) {
				this.$message.error('配置校验不通过！')
				return
			}
			if(!obj1["ZH"]){
				this.$message.error('中国配置不能为空！')
				return
			}
			const params = {
				"sid": this.selectedShopId,
				"companyId": this.str.company_id,
				"staffId": this.str.rid,
				"isVirtual": this.shopState === "real" ? 0: 1,
				"data": updateList
			}
			ajaxPost(Baseurl + "sellerCommonSettingController/batchSetSellerCommonSetting", params).then(res => {
				if (res.data.code === 200) {
					this.$message.success("当前店铺所有国家配置保存成功");
					this.loadShopConfigFromApi();
				} else {
					this.$message.error(res.data.data || "保存失败");
				}
			});
		},

		// 加载配置
		loadShopConfigFromApi() {
			ajaxPost(Baseurl + "sellerCommonSettingController/getSellerCommonSettingListOrigin", {
				sid: this.selectedShopId,
				staffId: this.str.rid,
				isVirtual: this.shopState === "real" ? 0: 1, // 0:真实店铺 1:虚拟店铺
			}).then(res => {
				if (res.data.code === 200 && res.data.data) {
					const dataList = res.data.data;
					const obj = {};
					const existCountryList = [];
					dataList.forEach(item => {
						obj[item.countryCode] = item;
						const item1 = {
							brand: '',
							sku: '',
							areaName: item.countryCode,
							startNumber: '',
							endNumber: '',
							maxNumber: item.pipeCode ? parseInt(item.pipeCode.replace(/\b(0+)/gi, "")) - 1 : 1,
							newBrand: item.field01 || '',
							newSku: item.field03 || '',
							eanStatus: item.eanStatus,
						}
						existCountryList.push(item1);
					})
					this.existCountryList = existCountryList;
					this.countryList = JSON.parse(JSON.stringify(COUNTRY_LIST.map(item => {
						const itemData = obj[item.areaName];
						if(itemData){
							return {
								pName: itemData.field01 || "",
								cName: itemData.field02 || "",
								set: itemData.stock || "",
								SKU: itemData.field03 || "",
								pipeCode: itemData.pipeCode.replace(/\b(0+)/gi, "") || "",
								name: item.name,
								areaName: item.areaName,
								eanStatus: itemData.eanStatus
							}
						}else{
							return {
								name: item.name,
								areaName: item.areaName,
								pName: "",
								cName: "",
								set: "",
								SKU: "",
								type: "",
								pipeCode: "",
								eanStatus: '',
							}
						}
						
					})));
				}else{
					this.countryList = JSON.parse(JSON.stringify(COUNTRY_LIST.map(item => {
						return {
							name: item.name,
							areaName: item.areaName,
							pName: "",
							cName: "",
							set: "",
							SKU: "",
							type: "",
							pipeCode: "",
							eanStatus: '',
						}
					})));
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.top-bar {
	margin-bottom: 16px;

	.bar-inner {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.label {
		margin-right: 8px;
	}

	.tag-virtual {
		color: #909399;
		font-size: 12px;
		margin-left: 8px;
	}
}

// 统一模板区域
.template-wrap {
	border: 1px solid #e4e7ed;
	border-radius: 4px;
	padding: 16px;
	margin-bottom: 20px;

	.template-header {
		font-size: 15px;
		font-weight: 500;
		margin-bottom: 16px;
		display: flex;
		align-items: center;

		.txt {
			margin-right: 16px;
		}
	}

	.template-row {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		gap: 24px;
	}
}

.sub-title {
	font-size: 14px;
	color: #666;
	margin-bottom: 12px;
}
.el-form-item{
	
	// margin-bottom: 0;
}
// 国家列表 一行一个国家
.country-list {
	.country-row {
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		padding: 10px;
		margin-bottom: 12px;
		gap: 16px;
		display: flex;
		align-items: center;
	}

	.country-name {
		width: 120px;
		font-weight: 500;
		white-space: nowrap;
		margin-top: 8px;
	}

	.country-input-group {
		display: flex;
		align-items: flex-start;
		gap: 36px;
		flex: 1;
		.el-form-item{
			flex: 1;
			/deep/ .el-form-item__content{
				width: 100% !important;
				display: flex;
			}
			/deep/ .el-input{
				flex: 1 !important;
			}
		}
	}
}

.form-cell {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 6px;

	.cell-label {
		white-space: nowrap;
		font-size: 13px;
	}

	.el-input {
		width: 160px;
	}

	// 清除element默认间距冲突
	::v-deep .el-form-item__error {
		padding-top: 2px;
	}
}

// 弹窗样式
.dialog-row {
	display: flex;
	align-items: center;
	padding: 8px 0;

	.dialog-label {
		width: 90px;
	}

	.el-input {
		flex: 1;
	}
}
.country-list-box{
	margin-top: 20px;
	.country-row{
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 8px 0;
		border-bottom: 1px solid #e4e7ed;
		&:last-child{
			border-bottom: none;
		}
		.right-item{
			display: flex;
			align-items: center;
			gap: 4px;
			.label{
				width: 80px;
				text-align: right;
			}
			.el-input{
				width: 160px;
			}
		}
		
	}
}
</style>